import { ItemService } from "@shared/service/items.service";
import { ItemInformationModel } from "./itemInformation.model";

export class CarruselClass {
  Familia: string;
  TipoCarrusel: number;
  CarruselDescription: string;
  ItemInformation: string;
  Currency: string;
  UserId: number;
  CustAccount: string;

  constructor() {
    this.Familia = '';
    this.TipoCarrusel = 0;
    this.CarruselDescription = '';
    this.ItemInformation = '';
    this.Currency = '';
    this.UserId = 0;
    this.CustAccount = '';
  }

  ObtenerCarrusel(itemService: ItemService) {

    const model = {
      TipoCarrusel : this.TipoCarrusel,
      Familia: this.Familia,
      UserId: this.UserId,
      CustAccount: this.CustAccount,
      Currency: this.Currency
    }

    return itemService.GetCarruselInformation(model);
  }
}
